import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const IntroOfferFilter = () => {
  const dispatch = useDispatch();
  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);
  const options = useSelector((state) => state.laser.introOfferOptions);
  const selected = useSelector((state) => state.laser.selectedFilters.introOfferFilters);
  const introOfferLoading = useSelector((state) => state.laser.introOfferLoading);

  return startFrom === "intro_offer" ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Intro Offer</p>
      {introOfferLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selected}
          numberDisplayed={0}
          includeSelectAll
          enableOnly
          onSelectChange={(data) => dispatch(actionCreators.setIntroOfferFilters(data))}
        />
      )}
    </div>
  ) : null;
};
